<template>
  <div>
    <!--头部-->
    <Header></Header>
    <slot></slot>
    <!--底部-->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
export default {
  name: 'Main',
  components: {
    Header,
    Footer,
  }
}
</script>

<style scoped>

</style>
